import {
  ITile,
  ListTile,
  ListTileType,
  QuickActionTile,
  QuickActionTileType,
  TileType,
} from '@varo/graphql-schema-types';
import { Action } from 'expo-quick-actions';
import { isNotNil } from 'shared/utils/isNotNil/isNotNil';

function mapTileToOSAction(
  quickActionTile: QuickActionTile,
): Action | undefined {
  const route = quickActionTile.onPress?.route;
  if (route) {
    switch (quickActionTile.quickActionTileType) {
      case QuickActionTileType.SendMoney:
        return {
          id: 'send-money',
          title: quickActionTile.title,
          icon: 'send_money',
          params: {
            href: route,
          },
        };
      case QuickActionTileType.TransferAch:
        return {
          id: 'transfer',
          title: quickActionTile.title,
          icon: 'transfer',
          params: {
            href: route,
          },
        };
      case QuickActionTileType.ViewCard:
        return {
          id: 'view-card',
          title: quickActionTile.title,
          icon: 'card',
          params: {
            href: route,
          },
        };
      case QuickActionTileType.FindAtm:
        return {
          id: 'find-atm',
          title: quickActionTile.title,
          icon: 'find_atm',
          params: {
            href: route,
          },
        };
      case QuickActionTileType.PayBills:
        return {
          id: 'pay-bills',
          title: quickActionTile.title,
          icon: 'pay_bills',
          params: {
            href: route,
          },
        };
      default:
        return;
    }
  }
  return;
}

const selectQuickActionsTile = (tiles: ITile[]): QuickActionTile[] => {
  const quickActionListTiles = tiles.filter((tile) => {
    if (tile.tileType === TileType.List) {
      const tileAsListTile = tile as ListTile;
      return tileAsListTile.listTileType === ListTileType.QuickActions;
    }
    return false;
  });
  if (quickActionListTiles.length < 1) {
    return [];
  }
  const [quickActionListTile] = quickActionListTiles as ListTile[];

  return quickActionListTile.tiles.filter(
    (tile) => tile.tileType === TileType.QuickAction,
  ) as QuickActionTile[];
};

const buildOSQuickActions = (tiles: ITile[]): Action[] => {
  const quickActionTiles = selectQuickActionsTile(tiles);
  return quickActionTiles
    .map((quickAction) => mapTileToOSAction(quickAction))
    .filter(isNotNil);
};

export default buildOSQuickActions;
